export default "__VITE_ASSET__DhXEj_gk__";